import { Routes, Route } from "react-router";
import { CookieBanner } from "./components/CookieBanner";
import { SidebarLayout } from "./layout/SidebarLayout";
import { CataloguePage } from "./routes/CataloguePage";
import { SignInPage } from "./routes/SignInPage";
import { AuthFinishPage } from "./routes/AuthFinishPage";
import { LandingPage } from "./routes/LandingPage";
import { CustomisePage } from "./routes/CustomisePage";
import { ApprovalPage } from "./routes/ApprovalPage";
import { OrderConfirmationPage } from "./routes/OrderConfirmationPage";
import { BrandLibraryPage } from "./routes/BrandLibraryPage";
import { DesignsPage } from "./routes/DesignsPage";
import { OrdersPage } from "./routes/OrdersPage";
import { ClientsPage } from "./routes/admin/ClientsPage";
import { CatalogueAdminPage } from "./routes/admin/CatalogueAdminPage";
import { OrdersAdminPage } from "./routes/admin/OrdersAdminPage";
import { AuditPage } from "./routes/admin/AuditPage";
import { TeamPage } from "./routes/settings/TeamPage";
import { ComingSoonPage } from "./routes/ComingSoonPage";

export function App() {
  return (
    <>
      <Routes>
        {/* Public routes — no sidebar chrome */}
        <Route index element={<LandingPage />} />
        <Route path="auth/signin" element={<SignInPage />} />
        <Route path="auth/finish" element={<AuthFinishPage />} />

        <Route element={<SidebarLayout />}>
          <Route path="catalogue" element={<CataloguePage />} />
          <Route path="catalogue/:kitId" element={<CustomisePage />} />
          <Route path="catalogue/:kitId/approval" element={<ApprovalPage />} />
          <Route path="catalogue/:kitId/order" element={<OrderConfirmationPage />} />
          <Route path="designs" element={<DesignsPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="brand-library" element={<BrandLibraryPage />} />
          <Route path="settings" element={<ComingSoonPage title="Settings" />} />
          <Route path="settings/team" element={<TeamPage />} />

          {/* Admin section — gated in Phase 2 via RBAC */}
          <Route path="admin">
            <Route index element={<ClientsPage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="catalogue" element={<CatalogueAdminPage />} />
            <Route path="orders" element={<OrdersAdminPage />} />
            <Route path="audit" element={<AuditPage />} />
          </Route>
        </Route>
      </Routes>
      {/* Cookie banner sits outside the layout so it appears on the landing
          page AND inside the app, on first visit only. */}
      <CookieBanner />
    </>
  );
}
